import React from "react";
import EconomicTable from "../EconomicTable";
import { useFundamentalsData } from "../../../context/FundamentalsContext";

const MacroTab = () => {
    const { filteredRows: rows } = useFundamentalsData();

    const data = rows
        .filter(row => row.Category === "MACRO")
        .map(row => {
            let topic = row.Topic;
            if (!topic) return row;
            const upperTopic = topic.toUpperCase();
            if (upperTopic.includes("MONETARY") || upperTopic.includes("FISCAL")) {
                topic = "Monetary & Fiscal Policy";
            } else if (upperTopic.includes("INDICATOR")) {
                topic = "Economic Indicator";
            } else if (upperTopic.includes("EVENT") || upperTopic.includes("DOMESTIC")) {
                topic = "Domestic Event";
            }
            return { ...row, Topic: topic };
        });

    const groupDescriptions = {
        "Economic Indicator": "Key economic metrics including GDP, Inflation, Employment data, etc.",
        "Monetary & Fiscal Policy": "Economic Policy: Internal economic policies such as monetary, fiscal, and environmental policy."
    };

    return <EconomicTable data={data} title="Macro Analysis" defaultRowData={{ Category: "MACRO", Topic: "Economic Indicator" }} groupBy="Topic" groupOrder={["Economic Indicator", "Monetary & Fiscal Policy", "Domestic Event"]} groupDescriptions={groupDescriptions} useDataHook={useFundamentalsData} showNextRelease={false} />;
};

export default MacroTab;
